/**
 * 回到顶部
 * 
 * @Author: Focci
 * @Date: 2023-08-12 13:29:55
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-12 13:29:55
 */

'use client'

import PropTypes from 'prop-types'
import { isWindow } from '@lib/utils'
import NorthIcon from '@mui/icons-material/North'
import { useCallback, useEffect, useState } from 'react'
import RoundTrigger from './RoundTrigger'

export default function BackTop({
  target, // 默认 window
  offset = 300, // 滚动条在距离顶部300px时，才显示
  children
}) {
  const [show, setShow] = useState(false)

  const handleBackTop = useCallback(() => {
    const targetEl = target || document.documentElement
    targetEl.scrollIntoView({ behavior: 'smooth' })
  }, [target])

  const handleScroll = useCallback(() => {
    const { scrollTop } = target || document.documentElement
    setShow(scrollTop > offset)
  }, [offset, target])

  useEffect(() => {
    if(!isWindow) return () => {}
    const targetEl = target || window

    handleScroll()
    targetEl.addEventListener('scroll', handleScroll, false)
    return () => {
      targetEl.removeEventListener('scroll', handleScroll, false)
    }
  }, [handleScroll, target])

  return show && (
    <div
      className="animate-fade-scale-in cursor-pointer"
      onClick={handleBackTop}
      onKeyPress={handleBackTop}
      tabIndex="0"
      role="button"
    >
      { children || <RoundTrigger><NorthIcon /></RoundTrigger> }
    </div>
  )
}

BackTop.propTypes = {
  target: PropTypes.node,
  offset: PropTypes.number,
  children: PropTypes.node,
}
